import { forwardRef, ForwardedRef, ChangeEvent } from 'react';
import { InputMaskProps } from '../../Types';

export const InputMask = forwardRef(
  ({ className, name, type, mask, placeholder, ...props }: InputMaskProps, ref: ForwardedRef<HTMLInputElement>) => {
    const PATTERN = /\D/g;
    const getInputNumbersValue = (value: string) => {
      return value.replace(PATTERN, '');
    };
    const handlePhoneInput = (event: ChangeEvent<HTMLInputElement>) => {
      const input = event.target;
      let inputNumbersValue = getInputNumbersValue(input.value);
      const selectionStart = input.selectionStart;
      if (!inputNumbersValue) {
        input.value = '';
        return;
      }
      if (input.value.length !== selectionStart) {
        return;
      }
      let formatInputValue;
      if (inputNumbersValue[0] === '7' || inputNumbersValue[0] === '8') {
        formatInputValue = '+7 ';
        if (inputNumbersValue.length >= 1) {
          formatInputValue += '(' + inputNumbersValue.substring(1, 4);
        }
      } else {
        inputNumbersValue = '8' + inputNumbersValue;
        formatInputValue = '+7 (' + inputNumbersValue[1];
        if (inputNumbersValue.length >= 1) {
          formatInputValue += inputNumbersValue.substring(2, 4);
        }
      }
      if (inputNumbersValue.length >= 5) {
        formatInputValue += ') ' + inputNumbersValue.substring(4, 7);
      }
      if (inputNumbersValue.length >= 8) {
        formatInputValue += '-' + inputNumbersValue.substring(7, 9);
      }
      if (inputNumbersValue.length >= 10) {
        formatInputValue += '-' + inputNumbersValue.substring(9, 12);
      }

      input.value = formatInputValue;
    };

    return (
      <>
        <input
          className={className}
          placeholder={(props.value as string)?.length ? mask : placeholder}
          maxLength={18}
          name={name}
          type={type}
          ref={ref}
          {...props}
          onInput={handlePhoneInput}
        />
      </>
    );
  },
);

InputMask.displayName = 'FormMaskInput';
